import { render, staticRenderFns } from "./OptionSwitch.vue?vue&type=template&id=21b28a23&"
import script from "./OptionSwitch.vue?vue&type=script&lang=js&"
export * from "./OptionSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports